import { useEffect, useState } from "react";
import { ChevronUp, ChevronDown, Eye, EyeOff, Copy, Trash2 } from "lucide-react";
import api from "@/lib/api";
import { toast } from "sonner";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";

const TYPES = ["hero", "brand_statement", "featured_products", "editorial", "material_story", "brand_philosophy", "newsletter", "collection", "cta", "campaign"];

export default function AdminHomepage() {
  const [sections, setSections] = useState([]);
  const [edit, setEdit] = useState(null);
  const load = () => api.get("/admin/homepage").then(({ data }) => setSections(data)).catch(() => {});
  useEffect(() => { load(); }, []);

  const move = async (idx, dir) => {
    const next = [...sections];
    const j = idx + dir;
    if (j < 0 || j >= next.length) return;
    [next[idx], next[j]] = [next[j], next[idx]];
    setSections(next);
    await api.post("/admin/homepage/reorder", { order: next.map((s) => s.id) });
  };
  const toggle = async (s) => { await api.put(`/admin/homepage/${s.id}`, { visible: !s.visible }); load(); };
  const dup = async (s) => { await api.post(`/admin/homepage/${s.id}/duplicate`); toast.success("Gedupliceerd"); load(); };
  const del = async (s) => { if (!window.confirm("Sectie verwijderen?")) return; await api.delete(`/admin/homepage/${s.id}`); load(); };
  const addSection = async () => { await api.post("/admin/homepage", { type: "editorial", visible: true, data: { eyebrow: "NIEUW", heading: "NIEUWE SECTIE", body: "Bewerk mij" } }); toast.success("Sectie toegevoegd"); load(); };

  const saveData = async () => { await api.put(`/admin/homepage/${edit.id}`, { type: edit.type, data: edit.data }); toast.success("Opgeslagen"); setEdit(null); load(); };

  return (
    <div data-testid="admin-homepage">
      <div className="flex items-center justify-between mb-6">
        <h1 className="heading-x text-2xl">STARTPAGINA CMS</h1>
        <button onClick={addSection} className="btn-x text-[0.65rem]" data-testid="add-section-btn">SECTIE TOEVOEGEN</button>
      </div>
      <div className="space-y-2">
        {sections.map((s, i) => (
          <div key={s.id} className="flex items-center gap-3 border border-[#E8E1D8] bg-white p-3" data-testid={`section-${s.id}`}>
            <div className="flex flex-col">
              <button onClick={() => move(i, -1)}><ChevronUp size={15} /></button>
              <button onClick={() => move(i, 1)}><ChevronDown size={15} /></button>
            </div>
            <div className="flex-1">
              <p className="text-sm font-medium">{(s.data?.heading) || s.type}</p>
              <p className="label-x mt-0.5">{s.type}</p>
            </div>
            <button onClick={() => toggle(s)} title="Zichtbaarheid">{s.visible ? <Eye size={16} /> : <EyeOff size={16} className="opacity-40" />}</button>
            <button onClick={() => setEdit(JSON.parse(JSON.stringify(s)))} className="label-x" data-testid={`edit-section-${s.id}`}>BEWERK</button>
            <button onClick={() => dup(s)}><Copy size={15} /></button>
            <button onClick={() => del(s)}><Trash2 size={15} /></button>
          </div>
        ))}
      </div>

      <Dialog open={!!edit} onOpenChange={(o) => !o && setEdit(null)}>
        <DialogContent className="max-w-lg bg-[#F7F5F1] max-h-[92vh] overflow-y-auto no-scrollbar">
          <DialogHeader><DialogTitle className="heading-x text-sm">SECTIE BEWERKEN</DialogTitle></DialogHeader>
          {edit && (
            <div className="space-y-3">
              <label className="block"><span className="label-x">TYPE</span>
                <select value={edit.type} onChange={(e) => setEdit({ ...edit, type: e.target.value })} className="w-full border border-[#E8E1D8] bg-white px-3 py-2 text-sm">
                  {TYPES.map((t) => <option key={t} value={t}>{t}</option>)}
                </select>
              </label>
              {Object.entries(edit.data || {}).map(([k, v]) => (
                typeof v === "string" || typeof v === "number" ? (
                  <label key={k} className="block"><span className="label-x">{k}</span>
                    <input value={v} onChange={(e) => setEdit({ ...edit, data: { ...edit.data, [k]: e.target.value } })} className="w-full border border-[#E8E1D8] bg-white px-3 py-2 text-sm" data-testid={`sec-field-${k}`} />
                  </label>
                ) : null
              ))}
              <label className="block"><span className="label-x">GEAVANCEERD (JSON DATA)</span>
                <textarea rows={6} defaultValue={JSON.stringify(edit.data, null, 2)} onBlur={(e) => { try { setEdit({ ...edit, data: JSON.parse(e.target.value) }); } catch { toast.error("Ongeldige JSON"); } }} className="w-full border border-[#E8E1D8] bg-white px-3 py-2 text-xs font-mono" data-testid="sec-json" />
              </label>
              <button onClick={saveData} className="btn-x" data-testid="save-section-btn">OPSLAAN</button>
            </div>
          )}
        </DialogContent>
      </Dialog>
    </div>
  );
}
